import { useEffect, useState } from "react";
import { Copy, Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiError } from "@/lib/api";

export const EmailDraft = ({ url, label = "Rédiger l'email au conseiller", testid = "email-draft" }) => {
  const [draft, setDraft] = useState(null);
  const [to, setTo] = useState("");
  useEffect(() => { setDraft(null); }, [url]);
  const load = async () => {
    try { const { data } = await api.get(url); setDraft(data); } catch (e) { toast.error(formatApiError(e)); }
  };
  if (!draft) return <Button variant="outline" className="w-full rounded-full" onClick={load} data-testid={`${testid}-button`}><Mail className="mr-2 h-4 w-4" /> {label}</Button>;
  const copy = async () => { await navigator.clipboard.writeText(`${draft.subject}\n\n${draft.body}`).catch(() => {}); toast.success("Email copié"); };
  const mailto = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(draft.subject)}&body=${encodeURIComponent(draft.body)}`;
  return (
    <div className="space-y-3 rounded-2xl border border-border bg-card/70 p-4" data-testid={testid}>
      <div className="flex items-center gap-2 text-sm font-bold"><Mail className="h-4 w-4" /> Modèle d'email (modifiable)</div>
      <div><Label className="text-xs">Destinataire (email du conseiller)</Label><Input type="email" value={to} onChange={(e) => setTo(e.target.value)} placeholder="conseiller@banque.fr" data-testid={`${testid}-to`} /></div>
      <div><Label className="text-xs">Objet</Label><Input value={draft.subject} onChange={(e) => setDraft({ ...draft, subject: e.target.value })} data-testid={`${testid}-subject`} /></div>
      <div><Label className="text-xs">Message</Label><Textarea value={draft.body} onChange={(e) => setDraft({ ...draft, body: e.target.value })} rows={14} className="text-sm" data-testid={`${testid}-body`} /></div>
      <p className="text-xs text-muted-foreground">Pensez à joindre le rapport PDF. Votre messagerie s'ouvre avec le texte pré-rempli.</p>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button variant="outline" className="rounded-full sm:flex-1" onClick={copy} data-testid={`${testid}-copy`}><Copy className="mr-2 h-4 w-4" /> Copier</Button>
        <Button asChild className="rounded-full sm:flex-1"><a href={mailto} data-testid={`${testid}-open-mail`}><Mail className="mr-2 h-4 w-4" /> Ouvrir dans ma messagerie</a></Button>
      </div>
    </div>
  );
};
